(function () {
  'use strict';

  var manualUntil = 0;
  var suppressed = [];
  var STYLE_ID = 'ra-ea-wheel-gate-style';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '[data-ra-ea-suppressed="true"]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function textOf(el) {
    return ((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isExtraDiscountTrigger(target) {
    if (!target || !target.closest) return false;
    var el = target.closest('button,a,[role="button"],div,span');
    if (!el) return false;
    var t = textOf(el);
    return t.indexOf('extra sconto') !== -1 || t.indexOf('extra discount') !== -1;
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    var s = window.getComputedStyle(el);
    return r.width > 120 && r.height > 120 && s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity || '1') > 0;
  }

  function scoreCandidate(el) {
    if (!isVisible(el)) return -1;
    var score = 0;
    var s = window.getComputedStyle(el);
    var txt = textOf(el);
    var ident = ((el.id || '') + ' ' + (el.className || '')).toLowerCase();
    if (el.getAttribute('role') === 'dialog' || el.getAttribute('aria-modal') === 'true') score += 6;
    if (s.position === 'fixed') score += 5;
    if (/popup|modal|spin|wheel|fortune|ea-/.test(ident)) score += 5;
    if (/spin|wheel|fortuna|sconto|discount|email|vinci|gira/.test(txt)) score += 3;
    if (el.querySelector('input[type="email"]')) score += 3;
    var z = parseInt(s.zIndex, 10);
    if (!isNaN(z) && z > 1000) score += 2;
    return score;
  }

  function findPopup() {
    var selectors = [
      '[role="dialog"]', '[aria-modal="true"]',
      '[class*="popup" i]', '[id*="popup" i]',
      '[class*="spin" i]', '[id*="spin" i]',
      '[class*="wheel" i]', '[id*="wheel" i]',
      '[class*="modal" i]', '[id*="modal" i]'
    ];
    var nodes = [];
    try { nodes = Array.prototype.slice.call(document.querySelectorAll(selectors.join(','))); } catch (e) { return null; }
    var best = null;
    var bestScore = 7;
    nodes.forEach(function (el) {
      var score = scoreCandidate(el);
      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    });
    return best;
  }

  function unlockPage() {
    [document.documentElement, document.body].forEach(function (el) {
      if (!el) return;
      if (el.style && el.style.overflow === 'hidden') el.style.overflow = '';
      if (el.classList) {
        Array.prototype.slice.call(el.classList).forEach(function (c) {
          if (/popup|modal/.test(c.toLowerCase()) && /open|lock|active|show/.test(c.toLowerCase())) {
            el.classList.remove(c);
          }
        });
      }
    });
  }

  function suppressPopup() {
    ensureStyle();
    var popup = findPopup();
    if (!popup) return false;
    if (popup.getAttribute('data-ra-ea-suppressed') !== 'true') {
      popup.setAttribute('data-ra-ea-suppressed', 'true');
      suppressed.push(popup);
    }
    unlockPage();
    return true;
  }

  function revealSuppressed() {
    var shown = false;
    suppressed = suppressed.filter(function (el) {
      if (!el || !document.documentElement.contains(el)) return false;
      if (el.getAttribute('data-ra-ea-suppressed') === 'true') {
        el.removeAttribute('data-ra-ea-suppressed');
        shown = true;
      }
      return true;
    });
    return shown;
  }

  function suppressForMoment() {
    var attempts = 0;
    function run() {
      attempts += 1;
      if (suppressPopup() || attempts >= 20) return;
      window.setTimeout(run, 50);
    }
    run();
  }

  document.addEventListener('click', function (event) {
    if (!isExtraDiscountTrigger(event.target)) return;
    manualUntil = Date.now() + 5000;
    if (revealSuppressed()) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('ea_popup_display', function () {
    if (Date.now() <= manualUntil) return;
    suppressForMoment();
  }, true);

  window.addEventListener('ea_popup_close', function () {
    suppressed = suppressed.filter(function (el) {
      return el && document.documentElement.contains(el);
    });
  }, true);

  ensureStyle();
})();